import { Component, EventEmitter, OnInit, Output, ViewChild, inject } from '@angular/core';
import { FormBuilder, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { BaseFormComponent, BaseListeComponent } from '@classes/extends';
import { SelectFiltre } from '@composants/index';
import { ApplicatifService, Profil, ProfilListeUtilisateur, ProfilService, RFApplicatif, RFOption } from '@estel-numerique/galaclick-api';
import { FiltreHelper, FiltresService, TypeFiltre } from '@estel-numerique/galaclick-core';
import { UtilDate } from '@services/index';
import { Constantes } from '@services/util/constantes';
import { lastValueFrom } from 'rxjs';
import { DroitsEnum } from '../constantes/droits.enum';
import { ProfilInfobulleEnum } from './profilInfobulleEnum';
import { FiltreGala } from '../composants/composants';
import { SelectFiltre as SelectFiltre_1, SelectGala, SelectOuiNon } from '../composants/select/select.component';
import { NgClass, NgTemplateOutlet } from '@angular/common';
import { CpIconSort } from '../composants/icons/icons.component';
import { ButtonGalaEditComponent } from '../composants/buttons/btn-gala-edit/btn-gala-edit.component';
import { ButtonGalaSearchComponent } from '../composants/buttons/btn-gala-search/btn-gala-search.component';
import { ButtonGalaDeleteComponent } from '../composants/buttons/btn-gala-delete/btn-gala-delete.component';
import { PaginationV2Component } from '../composants/paginationV2/paginationV2.component';
import { DialogGalaComponent } from '../composants/dialog-gala/dialog-gala.component';
import { InputGala } from '../composants/inputs/input.component';
import { MatButton } from '@angular/material/button';
import { MatTooltip } from '@angular/material/tooltip';
import { ButtonGalaComponent } from '../composants/buttons/btn-gala/btn-gala.component';




/**
  * Liste des profils
  */
@Component({
    templateUrl: './profilListe.component.html',
    styleUrls: ['./profil.component.css'],
    imports: [FiltreGala, SelectFiltre_1, NgClass, CpIconSort, ButtonGalaEditComponent, ButtonGalaSearchComponent, ButtonGalaDeleteComponent, PaginationV2Component]
})
export class ProfilListeComponent extends BaseListeComponent implements OnInit {
    private wsProfil = inject(ProfilService);
    public filtresService = inject(FiltresService);
    private dialog = inject(MatDialog);

    public titre: string;
    public codeModule: string = Constantes.CodeOption.OFICHIERDROIT; // Code module/option testé pour vérifier l'accès à cette fonction (si null = OK)

    @ViewChild('select', { static: true }) public select: SelectFiltre;

    public headElements: { libelle: string, tri: string, sortable: boolean }[] = [];
    protected lgTrad: Record<string, string> = {};
    protected lgTradFiltre: Record<string, string> = {};

    public filtreAppli: TypeFiltre<number>[] = [];
    get listeElementsAff() {
        return this.getListeAffichee<Profil>();
    }
    constructor() {
        super();
        this.titre = this.translate.instant("PROFILS");
    }

    ngOnInit() {
        super.ngOnInit();
        this.init().catch(e => this.util.fErreur(e));
        this.util.showLoader();

    }
    async init() {
        try {
            this.headElements = [
                { libelle: this.translate.instant("APPPROFIL.APPLICATIF") + " ", tri: 'NOMAPP', sortable: true },
                { libelle: this.translate.instant("APPPROFIL.NOMPROFIL") + " ", tri: 'PROFIL', sortable: true }];

            this.lgTrad = {
                DEBUT: this.translate.instant("DEBUT"),
                PRECEDENT: this.translate.instant("PRECEDENT"),
                SUIVANT: this.translate.instant("SUIVANT"),
                FIN: this.translate.instant("FIN"),
            };

            this.lgTradFiltre = {
                FILTRE: this.translate.instant("FILTER"),
                APPLICATIF: this.translate.instant("APPPROFIL.FILTRE_APPLICATIF"),
                NBPROFILS: this.translate.instant("APPPROFIL.FILTRE_NBPROFILS")
            };

            this.filtreAppli = await this.filtresService.getFiltreApplicatif();

            // Recupération de la liste des profils de l'organisme
            await this.getProfils();
        } catch (e) {
            this.util.fErreur(e);
        } finally {
            this.util.hideLoader();
        }
    }

    public checkCreer() {
        return this.droitsAccess.write;
    }

    // Ouverture de la modale en création de fiche profil
    public fClicCreer() {
        const dialogCreer = this.dialog.open(ProfilCreerComponent);
        dialogCreer.componentInstance.creation.subscribe((value) => {
            this.onCreerProfilModal(value).catch(e => this.util.fErreur(e));
        });
    }

    public checkFiltre() {
        return false;
    }

    public checkExport() {
        return true;
    }

    async getProfils() {
        const listeProfil: Profil[] = await lastValueFrom(this.wsProfil.getProfilListe());
        this.fSetListeElements(listeProfil);
    }

    // Exportation de la liste des profils
    public fClicExporter() {
        if (this.getListeFiltree().length <= 0) {
            this.util.showToastWarning(this.translate.instant("EXPORTCSVNO"));
        } else {
            this.util.fConfirm(this.translate.instant("EXPORTCSV", { libelle: "profils" }), () => {
                const tabExport: { APPLICATIF: string, PROFIL: string }[] = [{ APPLICATIF: this.translate.instant("APPPROFIL.APPLICATIF"), PROFIL: this.translate.instant("PROFIL") }];

                // On transfert juste les données utilises dans le tableau pour export
                for (const elem of this.getListeFiltree<Profil>()) {
                    tabExport.push({ APPLICATIF: elem.NOMAPP, PROFIL: elem.PROFIL });
                }

                this.downloadCSV(tabExport, "GALACLICK_" + this.translate.instant("PROFILS") + "_" + UtilDate.getDate_time());
            });
        }
    }

    protected filtrage() {
        let listeTemp = this.getListeElements();
        //On vérifie si tout les filtre sont a true ou false
        if (FiltreHelper.isFiltrageNecessaire(this.filtreAppli)) {
            listeTemp = this.getListeElements().filter((data: Profil) =>
                this.filtreAppli.find((f) => { return f.value === data.IDAPPLICATIF; }).filtre === true
            );
        }
        return listeTemp;
    }

    // CREATION
    // Utilisée en retour de la fenêtre modal de création
    public async onCreerProfilModal(profil: Profil) {
        if (this.droitsAccess.write) {
            // Ajoute le profil à la liste des profils affichées
            await this.getProfils();

            // Ouvre la modale en modification
            this.onEditProfilListe(profil.IDAPPLICATIF, profil.IDPROFIL);
        } else {
            this.util.fErreur(this.translate.instant("ACCESFONCTIONINTERDIT"));
        }
    }

    // MODIFICATION
    // Ouverture de la modal d'édition d'une fiche de profil
    public onEditProfilListe(applicatifID: number, profilID: number) {
        const dialogProfil = this.dialog.open(ProfilDetailsComponent, {
            data: {
                applicatifID: applicatifID,
                profilID: profilID
            } as ProfilDetailsComponentData
        });
        dialogProfil.componentInstance.modification.subscribe(() => {
            this.onEditProfilModal().catch(e => this.util.fErreur(e));
        });
    }

    // Utilisée en retour de la fenêtre modal de création
    public async onEditProfilModal() {
        if (this.droitsAccess.write) {
            // Update l'affiche de la liste des profils
            await this.getProfils();
        } else {
            this.util.fErreur(this.translate.instant("ACCESFONCTIONINTERDIT"));
        }
    }

    // SUPPRESSION
    public async onDeleteProfilListe(applicatifID: number, profilID: number) {
        if (this.droitsAccess.write) {
            // Test si le profil est utilisé.
            try {
                const indiceDg: number = this.getListeElements<Profil>().findIndex(data => data.IDPROFIL === profilID);
                if (indiceDg >= 0) {
                    const nomProfil: string = this.getElementFromListe<Profil>(indiceDg).PROFIL;
                    const listUtilisateurProfil: ProfilListeUtilisateur[] = await this.wsProfil.getProfilListeUtilisateur(profilID).toPromise();
                    if (listUtilisateurProfil.length <= 0) { // Profil est libre d'utilisation
                        if (await this.util.confirmation(this.translate.instant("SUPPRCONFIRM", { libelle: this.translate.instant("APPPROFIL.SUPPRPROFIL") + " : " + nomProfil }))) {
                            try {
                                this.util.showLoader();
                                await this.wsProfil.deleteProfil(applicatifID, profilID).toPromise();
                                await this.getProfils();
                                this.util.showToastSuccess(this.translate.instant("SUPPROK", { libelle: this.translate.instant("PROFIL") + " '" + nomProfil + "'" }));
                            } catch (e) {
                                this.util.fErreur(e);
                            } finally {
                                this.util.hideLoader();
                            }
                        }
                    } else {

                        const texteInfo: string = this.translate.instant("APPPROFIL.SUPPRUSED", { libelle: nomProfil });
                        /*
                        // Pas trouvé comment mettre les noms à la ligne dans un this.util.fErreur();
                        let texteInfo: string = "Ce profil ne peux etre supprimé car il est encore utilisé par :";
                        for (let i = 0; i < listUtilisateurProfil.length && i < 5; i++) {
                            texteInfo += "\n\r- " + listUtilisateurProfil[i].NOM + " " + listUtilisateurProfil[i].PRENOM;
                        }
                        if (listUtilisateurProfil.length > 10) {
                            texteInfo += "\n\r- ...";
                        }
                        */
                        this.util.fErreur(texteInfo);
                    }
                }
            } catch (e) {
                this.util.fErreur(e);
            }
        } else {
            this.util.fErreur(this.translate.instant("ACCESFONCTIONINTERDIT"));
        }
    }
}
/**
  * Création d'un profil
  */
@Component({
    styleUrls: ['./profil.component.css'],
    templateUrl: './profilCreer.component.html',
    imports: [DialogGalaComponent, FormsModule, ReactiveFormsModule, InputGala, SelectGala, MatButton]
})
export class ProfilCreerComponent extends BaseFormComponent implements OnInit {

    private formBuilder = inject(FormBuilder);
    private wsAppli = inject(ApplicatifService);
    private wsProfil = inject(ProfilService);
    private dialogRef = inject<MatDialogRef<ProfilCreerComponent>>(MatDialogRef);

    public titre: string;
    public codeModule: string = Constantes.CodeOption.OFICHIERDROIT; // Code module/option testé pour vérifier l'accès à cette fonction (si null = OK)

    @Output() creation: EventEmitter<Profil> = new EventEmitter<Profil>();

    protected lgTrad: Record<string, string>;

    public listeApplicatif: RFApplicatif[] = [];
    public formProfilAjout = this.formBuilder.group({
        IDAPPLICATIF: [0, [Validators.required]],
        PROFIL: ['', [Validators.required, Validators.minLength(5), Validators.maxLength(30)]]
    });;

    constructor() {
        super();
        this.dialogRef.addPanelClass('animate__animated');
        this.dialogRef.addPanelClass('animate__slideInRight');
        this.dialogRef.updatePosition({ right: '20px', top: '0px' });
    }

    ngOnInit() {
        super.ngOnInit();

        this.titre = this.translate.instant("APPPROFIL.NEW");

        this.lgTrad = {
            VAL: this.translate.instant("VAL"),
            PHAPP: this.translate.instant("APPPROFIL.APPLICATIF"),
            NEWPROFIL: this.translate.instant("APPPROFIL.NEW"),
            NOMPROFIL: this.translate.instant("APPPROFIL.NOMPROFIL")
        };
        this.show().catch(e => this.util.fErreur(e));
    }

    private async show() {
        try {
            this.util.showLoader();
            // Récupère la liste des applicatifs
            if (this.droitsAccess.write) {
                this.formProfilAjout.reset();
                this.formProfilAjout.markAsPristine();
                this.formProfilAjout.markAsUntouched();
            } else {
                this.formProfilAjout.controls.IDAPPLICATIF.disable();
                this.formProfilAjout.controls.PROFIL.disable();
                this.util.fErreur(this.translate.instant("ACCESFONCTIONINTERDIT"));
                this.hide();
            }
            this.listeApplicatif = await lastValueFrom(this.wsAppli.getApplicatifListe());
        } catch (e) {
            this.util.fErreur(e);
        } finally {
            this.util.hideLoader();
        }
    }

    public hide() {
        this.dialogRef.addPanelClass('animate__slideOutRight');
        setTimeout(() => this.dialogRef.close(), 1000);
    }

    public async onCreerProfil() {
        if (this.droitsAccess.write) {
            if (this.validationFormulaire(this.formProfilAjout) === true) {
                try {
                    let newProfil = {} as Profil;
                    newProfil.IDOC = this.sessionUser.ORGAOC.IDORGA;
                    newProfil.IDAPPLICATIF = this.formProfilAjout.getRawValue().IDAPPLICATIF;
                    newProfil.PROFIL = this.formProfilAjout.getRawValue().PROFIL;
                    newProfil = await lastValueFrom(this.wsProfil.postProfil(newProfil));
                    const indiceApplicatif: number = this.listeApplicatif.findIndex(data => data.IDAPPLICATIF === newProfil.IDAPPLICATIF);
                    newProfil.NOMAPP = this.listeApplicatif[indiceApplicatif].NOMAPP;
                    this.formProfilAjout.reset();
                    this.creation.emit(newProfil);
                } catch (e) {
                    this.util.fErreur(e);
                }
                this.hide();
            }
        } else {
            this.util.fErreur(this.translate.instant("ACCESFONCTIONINTERDIT"));
        }
    }
}


export interface ProfilDetailsComponentData {
    applicatifID: number;
    profilID: number;
}

/**
  * Montre le details d'un profil - Modification
  */
@Component({
    styleUrls: ['./profil.component.css'],
    templateUrl: './profilDetails.component.html',
    imports: [DialogGalaComponent, FormsModule, ReactiveFormsModule, InputGala, SelectOuiNon, NgTemplateOutlet, MatButton, MatTooltip, ButtonGalaComponent]
})
export class ProfilDetailsComponent extends BaseFormComponent implements OnInit {

    private formBuilder = inject(FormBuilder);
    private wsProfil = inject(ProfilService);
    private dialogRef = inject<MatDialogRef<ProfilDetailsComponent>>(MatDialogRef);
    public data = inject<ProfilDetailsComponentData>(MAT_DIALOG_DATA);

    public titre: string;
    public codeModule: string = Constantes.CodeOption.OFICHIERDROIT; // Code module/option testé pour vérifier l'accès à cette fonction (si null = OK)

    @Output() modification: EventEmitter<Profil> = new EventEmitter<Profil>();

    public idProfil = 0;

    protected descriptionsMap = new Map<number, string>();

    // listes services | fonctionnalités
    protected listeServices: RFOption[] = [];
    protected listeFonctionnalites: RFOption[] = [];

    public formProfil = this.formBuilder.group({
        PROFIL: ['', [Validators.required, Validators.minLength(5), Validators.maxLength(30)]],
        PORTEFEUILLE: [0, Validators.required]
    });
    private valueChange = false;

    protected lgTrad: Record<string, string>;

    public libAppli: string;
    public profilModif: Profil = {};

    constructor() {
        super();
        this.dialogRef.updateSize('520px');
        this.titre = this.translate.instant("PROFIL");
    }

    ngOnInit() {
        super.ngOnInit();

        this.lgTrad = {
            NOMPROFIL: this.translate.instant("APPPROFIL.NOMPROFIL"),
            APPLICATIF: this.translate.instant("APPPROFIL.APPLICATIF"),
            ENR: this.translate.instant("ENR"),
            RET: this.translate.instant("RET"),
            PORTEFEUILLE: this.translate.instant("APPPROFIL.PORTEFEUILLE")
        };

        this.show(this.data.applicatifID, this.data.profilID).catch(e => this.util.fErreur(e));
    }

    private async show(applicatifID: number, profilID: number) {
        if (!this.droitsAccess.write) {
            this.formProfil.controls.PROFIL.disable();
            this.formProfil.controls.PORTEFEUILLE.disable();
        }
        try {
            this.util.showLoader();
            this.formProfil.reset();

            this.profilModif = await lastValueFrom(this.wsProfil.getProfil(applicatifID, profilID));

            if (this.profilModif.IDPROFIL == null) {
                this.util.showToastWarning(this.translate.instant("APPPROFIL.NOOPTION"));
            } else {
                this.titre = this.translate.instant("MODIF");
                this.formProfil.patchValue(this.profilModif);
            }

            // Mets en place les traductions de libellé
            for (const elem of this.profilModif.OPTIONS) {
                this.insertDescriptionOption(elem);
                const cleMenu = Constantes.CodeMenu[elem.LIBOPTION as keyof typeof Constantes.CodeMenu];
                elem.LIBOPTION = cleMenu
                    ? (this.translate.instant(cleMenu, { libelle: elem.LIBOPTION }) || this.translate.instant('APPPROFIL.NOLIBMENU', { libelle: elem.LIBOPTION }))
                    : '';
            }

            this.listeServices = this.profilModif.OPTIONS.filter(x => x.ORDRE < 1000);
            this.listeFonctionnalites = this.profilModif.OPTIONS.filter(x => x.ORDRE >= 1000);

            this.formProfil.markAsUntouched(); // Le reset bascule le form en untouched = false !
            this.valueChange = false;

        } catch (e) {
            this.util.fErreur(e);
        } finally {
            this.util.hideLoader();
        }

    }

    public hide() {
        if (this.formProfil.touched || this.valueChange == true) {
            this.util.fConfirm(this.translate.instant("QUITNOSAVE"), () => { this.dialogRef.close(); });
        } else {
            this.dialogRef.close();
        }
    }

    public setModuleAccess(idModule: number, level: string) { // Le module est une option de niveau 1
        if (!this.droitsAccess.write) {
            return;
        }
        try {
            this.valueChange = true;

            // Recherche du module correspondant (module = option de niveau 1)
            let indiceModule: number = this.profilModif.OPTIONS.findIndex(x => x.IDOPTION === idModule);

            if (indiceModule > -1 && (level == DroitsEnum.Complet ||
                level === DroitsEnum.Visuel ||
                level === DroitsEnum.Interdit)) {
                // Modification de l'état du module
                this.profilModif.OPTIONS[indiceModule].DROIT = level;
                this.profilModif.OPTIONS[indiceModule].DROITPARENT = level;
                // Mémorisation de l'état du module
                const DroitParent: string = this.profilModif.OPTIONS[indiceModule].DROITPARENT;

                // Modification des ACCESSMODULE et DROITS dans les options enfants du module (les OPTIONS de NIVEAU 2)
                for (indiceModule = 0; indiceModule < this.profilModif.OPTIONS.length; indiceModule++) {
                    if (this.profilModif.OPTIONS[indiceModule].IDPARENT === idModule) {
                        this.profilModif.OPTIONS[indiceModule].DROITPARENT = DroitParent;

                        // On change le droit des options pour correspondre au maxi du module.
                        switch (level) {
                            case DroitsEnum.Visuel:
                                if (this.profilModif.OPTIONS[indiceModule].DROIT === DroitsEnum.Complet) {
                                    this.profilModif.OPTIONS[indiceModule].DROIT = DroitsEnum.Visuel;
                                }
                                break;
                            case DroitsEnum.Interdit:
                                if (this.profilModif.OPTIONS[indiceModule].DROIT === DroitsEnum.Complet ||
                                    this.profilModif.OPTIONS[indiceModule].DROIT === DroitsEnum.Visuel) {
                                    this.profilModif.OPTIONS[indiceModule].DROIT = DroitsEnum.Interdit;
                                }
                                break;
                        }
                    }
                }
            }
        } catch (e) {
            this.util.fErreur(e);
        }
    }

    public setOptionAccess(idOption: number, level: string) {
        if (!this.droitsAccess.write) {
            return;
        }
        try {
            this.valueChange = true;

            if (idOption >= 0 && (level === DroitsEnum.Complet ||
                level === DroitsEnum.Visuel ||
                level === DroitsEnum.Interdit)) {
                const indiceOption = this.profilModif.OPTIONS.findIndex(x => x.IDOPTION === idOption);

                if (indiceOption > -1) {
                    this.profilModif.OPTIONS[indiceOption].DROIT = level;
                }
            }
        } catch (e) {
            this.util.fErreur(e);
        }
    }

    public async onSaveProfil() {
        if (this.droitsAccess.write) {
            if (this.validationFormulaire(this.formProfil) === true) {
                try {
                    this.util.showLoader();
                    this.profilModif.PROFIL = this.formProfil.get('PROFIL').value;
                    this.profilModif.PORTEFEUILLE = this.formProfil.get('PORTEFEUILLE').value;

                    this.profilModif = await this.wsProfil.putProfil(this.profilModif.IDAPPLICATIF, this.profilModif.IDPROFIL, this.profilModif).toPromise();

                    this.modification.emit(this.profilModif);

                    this.util.showToastSuccess(this.translate.instant("MODIFOK", { libelle: this.translate.instant("PROFIL") + " '" + this.profilModif.PROFIL + "' " }));

                    this.valueChange = false;
                    this.formProfil.markAsUntouched(); // Le reset bascule le form en untouched = false !
                    this.hide();

                    this.formProfil.reset();
                } catch (e) {
                    this.util.fErreur(e);
                } finally {
                    this.util.hideLoader();
                }
            }
        } else {
            this.util.fErreur(this.translate.instant("ACCESFONCTIONINTERDIT"));
        }

    }

    private insertDescriptionOption(option: RFOption) {
        const key = option.LIBOPTION as keyof typeof ProfilInfobulleEnum;
        const description = ProfilInfobulleEnum[key];
        this.descriptionsMap.set(option.IDOPTION, description ?? "");
    }

}
